import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { getIsSearchModalShown } from '../../../redux/selectors';
import { openSearchModal, closeSearchModal } from '../../../redux/actions';
import { Props } from './SearchIconButton';

export type StateProps = Pick<Props, 'isSearchModalShown'>;
export type DispatchProps = Pick<Props, 'openSearchModal' | 'closeSearchModal'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, {}> = state => ({
  isSearchModalShown: getIsSearchModalShown(state),
});
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  openSearchModal,
  closeSearchModal,
};

export default connect(mapStateToProps, mapDispatchToProps);
